module.exports = __webpack_public_path__ + "df6a6bc701eb46d838b8d0ab0b2c6085.svg";


//////////////////
// WEBPACK FOOTER
// ../src/images/avatars/Avatar 5.svg
// module id = 795
// module chunks = 0